import { useDocument, type UseDocumentProps } from '@ztechapps/common.hook'
import type { PurchaseOrder } from '@ztechapps/common.contract'
import { singlePurchaseOrderQuery } from './graphql'
import { usePurchaseOrderIdParam } from './usePurchaseOrderIdParam'

export const usePurchaseOrderDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const purchaseOrderId = usePurchaseOrderIdParam()

  const defaultQuery = query ?? singlePurchaseOrderQuery

  return useDocument<PurchaseOrder>({ query: defaultQuery, _id: purchaseOrderId, ...props })
}
